export default {
  create: 'đang xử lý',
  paying: 'đang xử lý',
  timeout: 'thanh toán quá hạn',
  finish: 'hoàn thành',
  open: 'Mở',
  close: 'Gần',
  errorafter: 'bù đơn',
  success: 'thành công',
  success1: 'đã thanh toán',
  success2: ' bình thường',
  success3: 'thông qua',
  success4: 'gọi lại thành công',
  success5: 'thanh toán thành công',
  success6: 'bù đơn thành công',

  doing: 'đang xử lý',
  doing1: 'đang xử lý',
  doing2: 'chưa thanh toán',
  doing3: 'đang bù đơn',
  doing88: 'Bù đơn thủ công',

  error: 'thất bại',
  error1: 'chưa thanh toán',
  error2: ' vô hiệu hóa',
  error3: 'từ chối',
  error4: 'chưa gọi lại',
  error5: 'gọi lại thất bại',
  error6: 'thanh toán thất bại',
  error7: 'bù đơn thất bại',
  error8: 'chưa bù đơn',
  error9: 'bù đơn thanh toán thất bại',
  error10: 'bù đơn gọi lại thất bại',
  error11: 'Đơn hàng không hợp lệ',
  error12: 'Đơn hàng không hợp lệ',
  error13: 'Khóa',
  choose: 'Vui lòng chọn trước',
  worring: 'Hoạt động này có nhiều rủi ro, bạn có muốn tiếp tục không?',
  tip: 'gợi ý',
  confor: 'Chắc chắn',
  Cancel: 'Hủy bỏ',
  batchSuccess: 'Bổ sung đơn hàng hàng loạt thành công!',
  cancelOlder: 'Đã thực hiện lệnh bổ sung hàng loạt'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/status.js